import tunnelsReducer from './ducks/tunnels';

export default tunnelsReducer;
